import ICMAxios from '../ICMAxios';
import { ICreateLocation } from '../../interfaces/ICreateLocation';
import { IUpdateLocation } from '../../interfaces/IUpdateLocation';

const locationService = {
  createLocationAsync: (location: ICreateLocation): Promise<any> => 
    ICMAxios.post<any>('v1/Location/create', location),

  getAllLocations: (request: any): Promise<any> => 
    ICMAxios.post<any>(`v1/Location`, request),

  getLocationById: (locationId: number): Promise<any> => 
    ICMAxios.get<any>(`v1/Location/${locationId}/location`),

  updateLocation: (request: IUpdateLocation): Promise<any> => 
    ICMAxios.put<any>('v1/Location', request),

  updateStatusAsync: (request: any): Promise<any> => 
    ICMAxios.put<any>('v1/Location/status', request),

  getAreas: (): Promise<any> => 
    ICMAxios.get<any>(`v1/Location/area`)
};

export default locationService;